const TechnologyNames = 
{
    Production:
    {
        Bronze:"Bronze",
        Iron:"Iron",
        Coal:"Coal",
        Oil:"Oil",
        Agriculture:"Agriculture",
        Irrigation:"Irrigation",
        SelectiveBreeding:"Selective Breeding",
        MechanizedAgriculture:"Mechanized Agriculture"
    },
    Military:
    {
        Warrior: "Warrior",
        Swordsmen: "Swordsmen",
        Knights: "Knights",
        Riflemen: "Riflemen",
        Cavalrymen: "Cavalrymen",
        Cannon: "Cannon",
        ModernInfantry: "Modern Infantry",
        Tanks: "Tanks",
        Rockets: "Rockets",
        AirForces: "Air Forces"
    },
    Urban:
    {
        Philosophy: "Philosophy",
        Religion: "Religion",
        Theology: "Theology",
        Alchemy: "Alchemy",
        PrintingPress: "Printing Press",
        BreadAndCircuses: "Bread And Circuses",
        Drama: "Drama",
        OrganizedReligion: "Organized Religion",
        ScientificMethod: "Scientific Method",
        Journalism: "Journalism",
        TeamSports: "Team Sports",
        Opera: "Opera",
        Computers: "Computers",
        Multimedia: "Multimedia",
        ProfessionalSports: "Professional Sports",
        Movies: "Movies",
    },
    Special:
    {
        Cartography: "Cartography",
        Warfare: "Warfare",
        CodeOfLaws: "Code Of Laws",
        Masonry: "Masonry",
        Navigation: "Navigation",
        Strategy: "Strategy",
        JusticeSystem: "Justice System",
        Architecture: "Architecture",
        Satellites: "Satellites",
        MilitaryTheory: "Military Theory",
        CivilService: "Civil Service",
        Engineering: "Engineering",
    },
    Government:
    {
        Despotism: "Despotism",
        Monarchy: "Monarchy",
        Theocracy: "Theocracy",
        Republic: "Republic",
        ConstitutionalMonarchy: "Constitutional Monarchy",
        Communism: "Communism",
        Fundamentalism: "Fundamentalism",
        Democracy: "Democracy"
    }
}

module.exports = TechnologyNames;